import { render, staticRenderFns } from "./order_notes.vue?vue&type=template&id=d5d26eb6&scoped=true"
import script from "./order_notes.vue?vue&type=script&lang=js"
export * from "./order_notes.vue?vue&type=script&lang=js"
import style0 from "./order_notes.vue?vue&type=style&index=0&id=d5d26eb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d26eb6",
  null
  
)

export default component.exports